import React from 'react';
import { Grid } from '@mui/material';
import EstimatedSocialSecurityBenefits from '../../../../components/EstimatedSocialSecurityBenefits';
import DidYouKnow from './components/DidYouKnow';
import PlanGap from './components/PlanGap';
import SSBenefits from './components/SSBenefits';
import { useAppContext } from '../../../../context/appContext';

const Results = () => {
  const {
    store: {
      estimatedBenefits,
      benefitEstimator,
    },
  } = useAppContext();

  return (
    <Grid container>
      <EstimatedSocialSecurityBenefits potentialReduction={estimatedBenefits.potentialReduction} monthlyReduction={estimatedBenefits.monthlyReduction} lifetimeReduction={estimatedBenefits.lifetimeReduction} benefitEstimator={benefitEstimator} />
      {benefitEstimator && <SSBenefits />}
      <DidYouKnow />
      <PlanGap />
    </Grid>
  );
};

export default Results;
